import { Dispatch } from 'redux';

import { Events } from '../constants/webSocketConsts/events';
import { Contract } from '../entities/Contract';
import { contractsApi } from '../services/api';

import { updateListCache } from './updateListCache';

type ViewerInfo = { isClient: boolean; activeCompanyId: string | null };

// A client user only sees contracts for the company they are acting as, so a
// contract for another company must not land in their lists.
const isVisibleToViewer = (contract: Contract, info: ViewerInfo) =>
  !info.isClient ||
  contract.companyId === '' ||
  !info.activeCompanyId ||
  contract.companyId === info.activeCompanyId;

const updateCache = (
  event: Events,
  items: Contract[],
  info: ViewerInfo,
  draft?: Contract[],
) => {
  updateListCache(
    event,
    items.filter((contract) => isVisibleToViewer(contract, info)),
    draft,
    { key: 'ref' },
  );
};

export function handleContractUpdate(
  event: Events,
  items: Contract[],
  dispatch: Dispatch<any>,
  info: ViewerInfo,
) {
  // for contracts showing to client
  const contractItem = items.at(0);
  if (!contractItem) {
    console.warn('contractItem is undefined');
    return;
  }
  // for contracts showing to client
  dispatch(
    contractsApi.util.updateQueryData(
      'getContracts',
      { recipientId: contractItem.recipientId },
      (draft?: Contract[]) => {
        updateCache(event, items, info, draft);
      },
    ),
  );

  // for contracts showing in contract template detail page
  dispatch(
    contractsApi.util.updateQueryData(
      'getContracts',
      { contractTemplateId: contractItem.contractTemplateId },
      (draft?: Contract[]) => {
        updateCache(event, items, info, draft);
      },
    ),
  );

  // for contracts showing on submissions/requests page
  dispatch(
    contractsApi.util.updateQueryData(
      'getContracts',
      {},
      (draft?: Contract[]) => {
        updateCache(event, items, info, draft);
      },
    ),
  );
}
